export class Song {
    constructor(
        public title: string,
        public composer: string,
        public style: string,
        public keySignature: string,
        public timeSignature: string
        )
    {}
}